import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React from 'react'

const NextArrow = ({ onClick }) => {
  return (
    <button onClick={onClick} className="btn btn-light btn-sm me-2" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
        <i className="fa fa-angle-right"></i>
    </button>
  )
}

NextArrow.propTypes = {
    onClick: PropTypes.func
}

NextArrow.defaulProps = {
    onClick: noop
}

export default NextArrow
